export enum OrganizationType {
    Corporate = "Corporate",
    RegularSyndicate = "RegularSyndicate",
    RegularIndividual = "RegularIndividual"
}